import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createEducationSlice = createAsyncThunk(
  "education/createEducation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/education/createEducation", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getEducationSlice = createAsyncThunk(
  "education/getEducation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/education/getEducation", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateEducationSlice = createAsyncThunk(
  "education/updateEducation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/education/updateEducation", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteEducationSlice = createAsyncThunk(
  "education/deleteEducation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/education/deleteEducation", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  educations: [],
  loading: false,
  createEducationSuccessMessage: null,
  createEducationErrorMessage: null,
  updateEducationSuccessMessage: null,
  updateEducationErrorMessage: null,
  deleteEducationSuccessMessage: null,
  deleteEducationErrorMessage: null,
  searchEducationErrorMessage: null,
};

const educationSlice = createSlice({
  name: "education",
  initialState,
  reducers: {
    resetCreateEducationMessage: (state) => {
      state.createEducationSuccessMessage = null;
      state.createEducationErrorMessage = null;
    },
    resetUpdateEducationMessage: (state) => {
      state.updateEducationSuccessMessage = null;
      state.updateEducationErrorMessage = null;
    },
    resetDeleteEducationMessage: (state) => {
      state.deleteEducationSuccessMessage = null;
      state.deleteEducationErrorMessage = null;
    },
    resetSearchEducationMessage: (state) => {
      state.searchEducationErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createEducationSlice.pending, (state, action) => {
        state.loading = true;
        state.createEducationSuccessMessage = null;
        state.createEducationErrorMessage = null;
      })
      .addCase(createEducationSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createEducationErrorMessage = action.payload.result.message;
        } else {
          state.createEducationSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createEducationSlice.rejected, (state, action) => {
        state.loading = false;
        state.createEducationErrorMessage = action.payload.result.message;
      })
      .addCase(getEducationSlice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getEducationSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchEducationErrorMessage = action.payload.result.message;
        }
        state.educations = action.payload.result.list;
      })
      .addCase(getEducationSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchEducationErrorMessage = action.payload.result?.message;
      })
      .addCase(updateEducationSlice.pending, (state, action) => {
        state.loading = true;
        state.updateEducationSuccessMessage = null;
        state.updateEducationErrorMessage = null;
      })
      .addCase(updateEducationSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateEducationErrorMessage = action.payload.result.message;
        } else {
          state.updateEducationSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateEducationSlice.rejected, (state, action) => {
        state.loading = false;
        state.updateEducationErrorMessage = action.payload.result.message;
      })
      .addCase(deleteEducationSlice.pending, (state, action) => {
        state.loading = true;
        state.deleteEducationSuccessMessage = null;
        state.deleteEducationErrorMessage = null;
      })
      .addCase(deleteEducationSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteEducationErrorMessage = action.payload.result.message;
        } else {
          state.deleteEducationSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(deleteEducationSlice.rejected, (state, action) => {
        state.loading = false;
        state.deleteEducationErrorMessage = action.payload.result.message;
      });
  },
});

export const {
  resetCreateEducationMessage,
  resetUpdateEducationMessage,
  resetDeleteEducationMessage,
  resetSearchEducationMessage,
} = educationSlice.actions;
export default educationSlice.reducer;
